import { useContext } from 'react';

import { useAuth } from '../auth/AuthContext';


export const usePermission = () => {

    const { user } = useAuth();

    //console.log("----------------------------------------------------------");
    //console.log("CURRENT USER  : " + JSON.stringify(user));
    //console.log("----------------------------------------------------------");
    

    const permissions = user?.userPermissions || {};

    //console.log("----------------------------------------------------------");
    //console.log("CURRENT USER PERMISSION : " + JSON.stringify(permissions));
    //console.log("----------------------------------------------------------");

    /**
     * Check permission at any nesting level.
     *
     * Examples:
     *
     * can('dashboard', 'view')
     *
     * can('claimAndPayments', 'claimStatus', 'searchClaim')
     *
     * can('superAdmin', 'systemUsers', 'createAdminUser')
     */
    const can = (...keys) => {

        

        let current = permissions;

        //we have currently set up permissions for 'admin' user role only, so return true for all others  
        if (user?.userRole?.trim().toLowerCase() !== 'admin') {
            
            return true;
        }

        for (const key of keys) {

            current = current?.[key];

            if (current === undefined) {
                return false;
            }
        }

        return current === true;
    };


    /**
     * Check if user has ANY of the supplied permissions.
     *
     * Example:
     *
     * canAny(
     *     'claimAndPayments',
     *     ['search', 'viewClaimAppeal']
     * )
     */
    const canAny = (page, functionalities = []) => {

        return functionalities.some(
            functionality => can(page, functionality)
        );
    };


    /**
     * Check if user has ALL of the supplied permissions.
     *
     * Example:
     *
     * canAll(
     *     'claimAndPayments',
     *     ['search', 'requestEop']
     * )
     */
    const canAll = (page, functionalities = []) => {

        return functionalities.every(
            functionality => can(page, functionality)
        );
    };


    /**
     * Check ANY permission using complete permission paths.
     *
     * Example:
     *
     * canAnyPath([
     *     ['claimAndPayments', 'search'],
     *     ['claimAndPayments', 'viewClaimAppeal']
     * ])
     */
    const canAnyPath = (permissionPaths = []) => {

        return permissionPaths.some(
            permissionPath => can(...permissionPath)
        );
    };


    /**
     * Check ALL permissions using complete permission paths.
     */
    const canAllPath = (permissionPaths = []) => {

        return permissionPaths.every(
            permissionPath => can(...permissionPath)
        );
    };


    const hasPageAccess = (page, section = null) => {

        let pagePermissions = permissions?.[page];

        if (!pagePermissions) {
            return false;
        }

        if (section) {
            pagePermissions = pagePermissions?.[section];
        }

        const hasTruePermission = (value) => {

            if (value === true) {
                return true;
            }

            if (!value || typeof value !== 'object') {
                return false;
            }

            return Object.values(value).some(
                child => hasTruePermission(child)
            );
        };

        return hasTruePermission(pagePermissions);
    };


    return {
        can,
        canAny,
        canAll,
        canAnyPath,
        canAllPath,
        hasPageAccess
    };
};